<template>
  <div class="mod-keywords">
    <div class="mod-keywords__list">
      <div class="mod-keywords__row" v-for="item in list" :key="item.id">
        <div class="mod-keyword-row__content">
          <div v-if="!item.isRegex">
            <span class="mod-keyword-row__name">{{ item.content }}</span>
            <span class="mod-keyword-row__type">{{
              $t("view.settings.chatbot.text")
            }}</span>
          </div>
          <div v-else>
            <span class="mod-keyword-row__name">{{
              `/${item.content}/${item.regexFlags}`
            }}</span>
            <span class="mod-keyword-row__type">{{
              $t("view.settings.chatbot.regex")
            }}</span>
          </div>

          <div class="mod-keyword-row__actions">
            <fai
              class="mod-keyword-row__action"
              icon="trash"
              @click="$emit('delete', item.operation, item.id)"
            ></fai>
          </div>
        </div>
      </div>
    </div>

    <div v-show="visible" class="mod-keywords__new">
      <div class="new-mod-keyword__row">
        <in
          style="width: 200px;"
          v-model="newRow.content"
          :label="
            !newRow.isRegex
              ? $t('view.settings.chatbot.keyword')
              : $t('view.settings.chatbot.regex')
          "
        ></in>
        <sw-button
          v-model="newRow.isRegex"
          :label="$t('view.settings.chatbot.isRegex')"
        ></sw-button>
      </div>
      <div class="new-mod-keyword__row" v-show="newRow.isRegex">
        <sw-button v-model="newRow.regexFlags.g" label="g"></sw-button>
        <sw-button v-model="newRow.regexFlags.m" label="m"></sw-button>
        <sw-button v-model="newRow.regexFlags.i" label="i"></sw-button>
      </div>
      <btn
        icon="save"
        style="margin: 10px 0;"
        @click="create"
        :inactive="!newRow.content.length"
        >{{ $t("btn.save") }}</btn
      >
    </div>

    <span class="mod-keywords__add" @click="visible = !visible">{{
      !visible ? $t("btn.create") : $t("btn.close")
    }}</span>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    operation: Number
  },
  data() {
    return {
      visible: false,
      clearRow: {
        content: "",
        isRegex: false,
        regexFlags: {
          g: false,
          m: false,
          i: false
        }
      },
      newRow: {
        content: "",
        isRegex: false,
        regexFlags: {
          g: false,
          m: false,
          i: false
        }
      }
    }
  },
  methods: {
    create() {
      const flags = [];

      if (this.newRow.isRegex) {
        for (const k of Object.keys(this.newRow.regexFlags)) {
          if (this.newRow.regexFlags[k]) flags.push(k);
        }
      }

      const data = {
        operation: this.operation,
        content: this.newRow.content,
        isRegex: this.newRow.isRegex,
        regexFlags: this.newRow.isRegex ? flags.join("") : null
      }

      this.$emit("add", data)
    },

    clear() {
      this.newRow = JSON.parse(JSON.stringify(this.clearRow))
      this.visible = false
    }
  }
};
</script>

<style lang="scss" scoped>
.mod-keywords {
  &__row {
    margin-bottom: 5px;
  }

  &__add {
    display: block;
    @include clickableText();
    text-align: left;
    margin-top: 15px;
  }

  &__new {
    margin-top: 25px;
  }
}

.mod-keyword-row {
  &__type {
    color: $borderAccent;
    font-weight: 700;
    font-size: 0.85em;
    margin-left: 4px;
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }

  &__action {
    cursor: pointer;
  }
}

.new-mod-keyword {
  &__row {
    display: flex;
    margin-bottom: 12px;

    & > *:not(:last-child) {
      margin-right: 10px;
    }

    & > *:not(:first-child) {
      margin-left: 10px;
    }
  }
}
</style>
